<div class="row p-1">
    <div class="col-12 pageTitle">
        <h2>&nbsp;&nbsp;&nbsp;User List</h2>
    </div>
</div>
<div class="card">
    <div class="p-fluid formgrid grid">

        <div class="field col-12 md:col-3">
            <span class="p-float-label PL-3">
                <input id="float-input1"
                       pInputText
                       [(ngModel)]="loginName"
                       type="text"
                       class="textboxBorder-1" />
                <label for="float-input" class="f1">Login Name:</label>
            </span>
        </div>
        <div class="field col-12 md:col-3">
            <span class="p-float-label">
                <input id="float-inpu1t"
                       pInputText
                       [(ngModel)]="lastName"
                       type="text"
                       class="textboxBorder-1" />
                <label for="float-input1" class="f1">Last Name:</label>
            </span>
        </div>

        <div class="field col-12 md:col-3">
            <span class="p-float-label PL-3">
                <input id="float-input1"
                       pInputText
                       [(ngModel)]="firstName"
                       type="text"
                       class="textboxBorder-1" />
                <label for="float-input" class="f1">First Name:</label>
            </span>
        </div>

        <span class="pt-1">
            &nbsp;
            <button pButton
                    type="button"
                    icon="pi pi-search"
                    label="Search"
                    (click)="getUserList(1, '', '')"
                    class="ui-button-plain buttonWidth-8 ml-3"></button>
            &nbsp;<button pButton
                          label="Clear"
                          severity="secondary"
                          icon="pi pi-refresh"
                          class="buttonWidth-8 fl ml-1 GreyButton"
                          (click)="clearUserList()"></button>
        </span>
    </div>
</div>
<div class="field col-2 md:col-2 mb-0 pb-2">
    <button pButton
            type="button"
            label="Create User"
            pTooltipPosition="true"
            icon="pi pi-user-plus"
            class="ui-button-plain buttonWidth-10 GreyButton"
            (click)="onAddNewUser()"></button>
</div>
<p-table *ngIf="users"
         [resetPageOnSort]="false"
         lazy="true"
         (onLazyLoad)="nextPage($event)"
         [totalRecords]="users?.totalRecords"
         [currentPageReportTemplate]="'{currentPage} of {totalPages}'"
         [columns]="cols"
         [alwaysShowPaginator]="false"
         [rows]="rows"
         [paginator]="true"
         [value]="users?.data"
         selectionMode="single"
         [sortOrder]="1"
         sortField="loginId"
         dataKey="loginId"
         [(selection)]="selectedUser"
         [autoLayout]="true"
         [(first)]="first">
    <ng-template pTemplate="header" let-columns>
        <tr *ngIf="Showrecords == true">
            <ng-template ngFor let-col [ngForOf]="columns" let-i="index">
                <th *ngIf="col.sort == true" [pSortableColumn]="col.field">
                    {{ col.header }}
                    <p-sortIcon [field]="col.field"></p-sortIcon>
                </th>
                <th *ngIf="col.sort == false">
                    {{ col.header }}
                </th>
            </ng-template>
            <th class="col-12 md:col-1" style="text-align: left !important">
                Status
            </th>
            <th class="col-12 md:col-1" style="text-align: left !important">
                Actions
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr [pSelectableRow]="rowData">
            <td *ngFor="let col of columns">
                <div *ngIf="col.subfield; then nested_object_content; else normal_content"></div>
                <ng-template #nested_object_content>
                    {{ rowData[col.field][col.subfield] }}
                </ng-template>
                <ng-template #normal_content>
                    {{ rowData[col.field] }}
                </ng-template>
            </td>

            <td style="text-align: left !important">
                <span *ngIf="rowData['active'] == true; else falsy">
                    <button pButton
                            pRipple
                            icon="pi pi-check"
                            class="p-button-rounded p-button-success"></button>
                </span>
                <ng-template #falsy>
                    <span>
                        <button pButton
                                pRipple
                                icon="pi pi-times"
                                class="p-button-rounded p-button-danger"></button>
                    </span>
                </ng-template>
            </td>

            <td style="text-align: center !important; display: flex">
                <div class="flex" style="justify-content: center">
                    <button pButton
                            type="button"
                            icon="pi pi-pencil"
                            class="p-button-link"
                            pTooltip="Edit"
                            (click)="onEditUser(rowData['userId'])"></button>
                    <button pButton
                            type="button"
                            icon="pi pi-trash"
                            class="p-button-link ml-3"
                            pTooltip="Delete"
                            (click)="dropuser($event, rowData['userId'])"
                            [disabled]="rowData['userId'] == loginUserId"></button>

                    <!--<button pButton type="button" icon="pi pi-lock-open" class="p-button-link ml-3"
                              *ngIf="!rowData['isLocked']" (click)="lock(rowData)" pTooltip="click to Lock"></button>-->
                    <button pButton
                            type="button"
                            icon="pi pi-qrcode"
                            class="p-button-link ml-3"
                            (click)="removeAutKey(rowData)"
                            pTooltip="Reset MFA"
                            [disabled]="!(rowData['authAppSetup'] == 'Y')"></button>
                </div>
                <button pButton
                        type="button"
                        icon="pi pi-lock"
                        class="p-button-link ml-3"
                        *ngIf="rowData['isLocked']"
                        (click)="unlock(rowData)"
                        pTooltip="click to UnLock"></button>
                <!--<button pButton type="button" icon="pi pi-refresh" class="p-button-link ml-5"  (click)="removeAutKey(rowData)" pTooltip="click to reset 2FA" ></button>-->
                <!--<span class="material-icons" *ngIf="!rowData['isLocked']" (click)="lock(rowData)" pTooltip="click to lock">


                            lock
                        </span>

                        <span class="material-icons" *ngIf="rowData['isLocked']" (click)="unlock(rowData)" pTooltip="click to unlock">
                            lock_open
                        </span>-->
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <div class="w-12 bg-white">
            <div class="" style="text-align: center">
                <img _ngcontent-ng-c683320295=""
                     class="profile-image"
                     style="border-radius: 50%; width: 10rem; padding-top: 1rem"
                     src="assets/imagesNew/table_error.png" />
            </div>
            <hr style="margin-bottom: 0.5rem" />
            <div class=""
                 style="text-align: center; font-size: larger; color: #1d428f">
                <i>No records found</i>
            </div>
        </div>
    </ng-template>
</p-table>
